import React from 'react';
import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom';
import Header from '../components/header/Header';
import Home from '../pages/home/Home';
import Atletas from '../pages/time/Atletas';
import Embaixadores from '../pages/time/Embaixadores';
import Escolas from '../pages/centros/Escolas';
import Hoteis from '../pages/centros/Hoteis';
import Servicos from '../pages/centros/Servicos';
import Revendedores from '../pages/centros/Revendedores';
import Footer from '../components/footer/Footer';
import Sustentabilidade from '../pages/sustentabilidade/Sustentabilidade';
import ProjetoSocial from '../pages/projetosocial/ProjetoSocial';
import ProjetoVivo from '../pages/projetosocial/ProjetoVivo';
import InstitutoSer from '../pages/projetosocial/InstitutoSer';
import ScrollToTop from '../components/scroll/ScrollToTop';
import WhatsappFloatingButton from '../components/buttons/WhatsappFloatingButton';
import { Box } from '@mui/material';

// Layout com o AppBar que envolve as rotas protegidas
const Layout: React.FC = () => {
  return (
    <Box sx={{ width: "100%", minHeight: "100vh", overflowX: "hidden" }}>
      <ScrollToTop />
      <Header />
      <Outlet />
      <Footer />
      <WhatsappFloatingButton/>
    </Box>
  );
};

// Definição das rotas
const router = createBrowserRouter([
  {
    path: '/',
    element:
      <Layout />
    ,
    children: [
      {
        path: '/',
        element: <Home />,
      },
      {
        path: 'pontovenda',
        element: <Revendedores />,
      },
      {
        path: 'servicos',
        element: <Servicos />,
      },
      {
        path: 'hoteisgastronomia',
        element: <Hoteis />,
      },
      {
        path: 'escolas',
        element: <Escolas />,
      },
      {
        path: 'atletas',
        element: <Atletas />,
      },
      {
        path: 'embaixadores',
        element: <Embaixadores />,
      },
      {
        path: 'sustentabilidade',
        element: <Sustentabilidade />,
      },
      {
        path: 'projetosocial',
        element: <ProjetoSocial />,
      },
      {
        path: 'projetovivo',
        element: <ProjetoVivo />,
      },
      {
        path: 'institutoser',
        element: <InstitutoSer />,
      },
    ],
  },
]);

// Componente principal do roteador
export default function Router() {
  return <RouterProvider router={router} />;
}
